import {
    TimePicker as MaterialTimePicker,
    TimePickerProps,
} from '@mui/x-date-pickers';
import { Moment } from 'moment';

export const TimePicker = (props: TimePickerProps<Moment>) => {
    return (
        <MaterialTimePicker data-testid={'TimePicker-container'} {...props} />
    );
};

export default TimePicker;
